import { MadSDKAPIError } from "../../errors/base";
export class ArchiveFootTrafficReportFailure extends MadSDKAPIError {
    constructor(reportId, originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ArchiveFootTrafficReportFailure);
        }
        this.name = "ArchiveFootTrafficReportFailure";
        this.reportId = reportId;
        this.message = `Failed to archive the report with ID ${reportId}.`;
    }
}
export class UnarchiveFootTrafficReportFailure extends MadSDKAPIError {
    constructor(reportId, originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnarchiveFootTrafficReportFailure);
        }
        this.name = "UnarchiveFootTrafficReportFailure";
        this.reportId = reportId;
        this.message = `Failed to unarchive the report with ID ${reportId}.`;
    }
}
export class FootTrafficAttributionReportsFetchFailure extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FootTrafficAttributionReportsFetchFailure);
        }
        this.name = "FootTrafficAttributionReportsFetchFailure";
        this.message =
            "Failed to retrieve foot traffic attribution reports. Please try again at a later time.";
    }
}
//# sourceMappingURL=errors.js.map